import { useState, useEffect } from 'react'
import { Wifi, WifiOff } from 'lucide-react'
import { isOnline, onOnlineStatusChange } from '../utils/offline'

export function NetworkStatus() {
  const [online, setOnline] = useState(isOnline())

  useEffect(() => {
    onOnlineStatusChange(setOnline)
  }, [])

  if (online) return null

  return (
    <div className="fixed top-16 left-4 right-4 bg-orange-500 text-white px-3 py-2 rounded-lg shadow-lg z-40 flex items-center justify-center">
      <WifiOff size={16} className="mr-2" />
      <span className="text-sm">오프라인 모드</span>
    </div>
  )
}

